import React from 'react';
import { Lock, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const SubscriptionLockOverlay = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div style={styles.iconWrapper}>
          <Lock size={48} color="#D4AF37" />
        </div>
        <h2 style={styles.heading}>Account On Hold</h2>
        <p style={styles.message}>
          Your business's subscription is currently not active. Contact your administrator
          or reach out to 1ne S.P.A support.
        </p>
        <a href="mailto:support@1nespa.com" style={styles.supportLink}>
          support@1nespa.com
        </a>
        <button onClick={handleSignOut} style={styles.signOutBtn}>
          <LogOut size={16} />
          Sign Out
        </button>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '20px'
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '48px 40px',
    maxWidth: '440px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.1), 0 4px 20px rgba(0, 0, 0, 0.05)'
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px'
  },
  heading: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1a1a2e',
    margin: '0 0 12px 0'
  },
  message: {
    fontSize: '15px',
    color: '#64748b',
    lineHeight: '1.6',
    margin: '0 0 16px 0'
  },
  supportLink: {
    display: 'block',
    fontSize: '14px',
    color: '#37A797',
    textDecoration: 'none',
    fontWeight: '500',
    marginBottom: '28px'
  },
  signOutBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 24px',
    backgroundColor: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#475569',
    cursor: 'pointer',
    transition: 'all 0.2s'
  }
};

export default SubscriptionLockOverlay;
